import React from 'react';

const Footer = () => {
  return (
    <footer className="footer pt-5 pb-5">
        <div className="container">
            <div className="row justify-content-between mb-5 g-xl-5">
                <div className="col-md-4 mb-5 mb-lg-0">
                    <img className="logo dark img-fluid" src="/assets/images/Sports_Logo.png" alt="FreeBootstrap.net image placeholder" style={{ background: 'white', borderRadius: '20px', padding: '3px', marginBottom: '20px'}} />
                    <p className="mb-4">Your ultimate destination for sports news, analysis, and community. Join us to celebrate the passion of the game.</p>
                    <div className="social-links">
                        <a href="#"><i className="bi bi-twitter" /></a>
                        <a href="#"><i className="bi bi-facebook" /></a>
                        <a href="#"><i className="bi bi-instagram" /></a>
                        <a href="#"><i className="bi bi-linkedin" /></a>
                    </div>
                </div>
                <div className="col-md-7">
                    <div className="row g-2">
                        <div className="col-md-6 col-lg-6 mb-4 mb-lg-0">
                            <h3 className="mb-3">Explore</h3>
                            <ul className="list-unstyled">
            
                                <li><a href="#about">About Us</a></li>
                                <li><a href="#WhyChoose">Why Choose</a></li>
                                <li><a href="#OurActivity">Our Activity</a></li>
                                <li><a href="#ContactUs">Contact Us</a></li>

                            </ul>
                        </div>
                       <div className="col-md-6 col-lg-6 mb-4 mb-lg-0">
  <h3 className="mb-3">Gallery</h3>

  <div className="row g-2">
    <div className="col-6">
      <img
        src="/assets/images/indian-cricket-academy-scene-featuring-600nw-2596645593.webp"
        alt="Gallery 1"
        className="img-fluid rounded"
        style={{ width: '141px', height: '100px', objectFit: 'cover' }}
      />
    </div>

    <div className="col-6">
      <img
        src="/assets/images/cricket-sport-materials-laying-on-600nw-2587343655.webp"
        alt="Gallery 2"
        className="img-fluid rounded"
        style={{ width: '141px', height: '100px', objectFit: 'cover' }}
      />
    </div>

    <div className="col-6">
      <img
              src="/assets/images/cricket-bat-leans-against-stumps-rich-green-pitch-red-ball-rests-nearby-sport-activity-equipment-grass-sunny-outdoors-summer-384919252.webp"
        alt="Gallery 3"
        className="img-fluid rounded"
        style={{ width: '141px', height: '100px', objectFit: 'cover' }}
      />
    </div>

    <div className="col-6">
      <img
        src="/assets/images/model-cricket-academy-dangra-tohana-cricket-coaching-classes-m040a9uhhu-250.avif"
        alt="Gallery 4"
        className="img-fluid rounded"
        style={{ width: '141px', height: '100px', objectFit: 'cover' }}
      />
    </div>
  </div>
</div>

                    </div>
                </div>
            </div>
            <div className="row credits">
                <div className="col-xl-12 text-center mb-3 mb-xl-0">
                    Copyright © 2026 All Rights Reserved. Handmade   <i className="bi bi-heart-fill text-danger" /> by <a href="https://anaxistech.com/" target="_blank" rel="noopener noreferrer">AnaxisTech</a>
                </div>
            </div>
        </div>
    </footer>
  );
};

export default Footer;
